/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ContentRecord,
  Enums,
  Environment,
  GeneratedContentDetails,
} from '@cyborg-monorepo/hunter/common';
import { generateContent } from '@cyborg-monorepo/hunter/matchboi';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface EnvironmentFilters {
  environments?: Array<string>;
  tools?: Array<string>;
  categories?: Array<string>;
}

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Get generated content for a given content record
   */
  public getContent(
    content: Partial<ContentRecord>,
  ): Observable<GeneratedContentDetails> {
    return of(this.generateContentDetails(content, content.content));
  }

  /**
   * Get all additional generated content for a given content record
   */
  public getAdditionalContent(
    content: Partial<ContentRecord>,
  ): Observable<GeneratedContentDetails[]> {
    return of(
      content.additional_queries.map((query) =>
        this.generateContentDetails(content, query),
      ),
    );
  }

  private generateContentDetails(
    content: Partial<ContentRecord>,
    targetContentTemplate: string,
  ): GeneratedContentDetails {
    const generatedContents = generateContent(
      targetContentTemplate,
      content.tool,
      content.deployment_requirements.categories,
    );

    return {
      tool: content.tool,
      content: generatedContents.map((generatedContent) => {
        return {
          query: generatedContent.query,
          category: generatedContent.category,
          status: Enums.QueryStatusEnum.TO_DO
        };
      }),
    };
  }

  public getHuntPackageContent(
    uuid: string,
    envFilters?: EnvironmentFilters,
  ): Observable<Environment[]> {
    let params = new HttpParams();

    if (envFilters?.environments)
      envFilters.environments.forEach((env) => {
        params = params.append('environments', env);
      });

    if (envFilters?.tools)
      envFilters.tools.forEach((tool) => {
        params = params.append('tools', tool);
      });

    if (envFilters?.categories)
      params = params.append('categories', envFilters?.categories?.join(', '));

    return this.httpClient.get<any>(
      `${environment.api}/es/cyborg-hunt-package/${uuid}/content`,
      {
        params: params,
      },
    );
  }

  public generateCustomContent(
    customHuntPackageUUID: string,
    envFilters?: EnvironmentFilters,
  ): Observable<Environment[]> {
    let params = new HttpParams();

    if (envFilters?.environments)
      envFilters.environments.forEach((env) => {
        params = params.append('environments', env);
      });

    if (envFilters?.tools)
      envFilters.tools.forEach((tool) => {
        params = params.append('tools', tool);
      });

    if (envFilters?.categories)
      params = params.append('categories', envFilters?.categories?.join(', '));

    params = params.append('customHuntPackageUUID', customHuntPackageUUID);

    return this.httpClient.get<any>(
      `${environment.api}/es/cyborg-custom-hunt-package/generate-content/`,
      {
        params: params,
      },
    );
  }
}
